var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#EDECE8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.963 10c3.38 0 6.392-1.667 9.037-5-2.645-3.333-5.657-5-9.037-5C5.583 0 2.596 1.667 0 5c2.596 3.333 5.584 5 8.963 5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 5,
    r: 2
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M2.5 15.5l15-15"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEye);
export default __webpack_public_path__ + "static/media/noEye.f03aa984a55613649ddd646fbd1f5a59.svg";
export { ForwardRef as ReactComponent };